<div class="tab-group">
  @for (tab of tabs; track tab) {
  <div
    class="tab"
    [class.disabled]="tab.disabled()"
    [class.active]="tab.active()"
    translate
    (click)="select(tab)"
    (keyup.enter)="select(tab)"
    tabindex="0"
  >
    {{ tab.label() }}
  </div>
  }
</div>
<div class="tab-pane">
  <ng-content></ng-content>
</div>
